export const FLYOUT_SCROLL_CONTAINER = 'flyout-scroll-container';

// Smoothly scroll to an element by ID
export const windowScrollToId = (id: string): void => {
  setTimeout(() => {
    const element = document.querySelector(`#${id}`);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    } else {
      console.warn(`Element with ID '${id}' not found.`);
    }
  }, 300);
};

// Scroll to the top of the element with ID 'main' or classSelector
export const windowScrollTop = (smooth: boolean = false): void => {
  setTimeout(() => {
    const element =
      document.querySelector(`.${FLYOUT_SCROLL_CONTAINER}`) ||
      document.getElementById('main');

    if (element) {
      element.scrollTo({
        top: 0,
        left: 0,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }
  }, 200);
};

// Scroll to the bottom of the element with ID 'main'
export const windowScrollBottom = (smooth: boolean = false): void => {
  const mainElement = document.getElementById('main');
  if (mainElement) {
    mainElement.scrollTo({
      top: mainElement.scrollHeight, // Use element's scrollHeight for bottom
      left: 0,
      behavior: smooth ? 'smooth' : 'auto',
    });
  } else {
    console.warn("Element with ID 'main' not found.");
  }
};

// Utility function to introduce a delay
export const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

// Caches the result of the Safari check
let isSafariCached: boolean | null = null;

// Check if the browser is Safari
export const isSafari = (): boolean => {
  if (isSafariCached === null) {
    const ua = navigator?.userAgent || '';
    const chromeRegex = /chrome|crios|crmo/i;
    const safariRegex = /safari|applewebkit/i;
    isSafariCached = !chromeRegex.test(ua) && safariRegex.test(ua);
  }
  return isSafariCached;
};

// Caches the result of the iOS check
let isIosCached: boolean | null = null;

// Check if the device is running iOS
export const isIos = (): boolean => {
  if (isIosCached === null) {
    const ua = navigator?.userAgent || '';
    isIosCached = /iPad|iPhone|iPod/.test(ua);
  }
  return isIosCached;
};

export const getDeviceType = () =>
  window?.innerWidth > 820 ? 'Desktop' : 'Mobile';

export const scrollTop = (scrollRef: React.RefObject<HTMLDivElement>) => {
  scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
};

const scrollDistance = 270;

export const horizontalScroll = (
  scrollRef: React.RefObject<HTMLDivElement>,
  direction: 'left' | 'right',
) => {
  if (scrollRef.current) {
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollDistance : scrollDistance,
      behavior: 'smooth',
    });
  }
};
